<button type="button" class="btn-common btn-primary" (click)="openMedia()">{{buttonLabel}}</button>
